module.exports = __webpack_public_path__ + "static/img/injectionProduction.f5237c19.png";